import { render, staticRenderFns } from "./realEstateContractFeature.vue?vue&type=template&id=89c16ad0&scoped=true&"
import script from "./realEstateContractFeature.vue?vue&type=script&lang=js&"
export * from "./realEstateContractFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c16ad0",
  null
  
)

export default component.exports